import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-037fbe72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-header" }
const _hoisted_2 = { class: "table table-fixed mt-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      width: "30%",
      class: "align-middle"
    }, "Company"),
    /*#__PURE__*/_createElementVNode("th", {
      width: "70%",
      class: "align-middle"
    }, "Branch")
  ])
], -1))
const _hoisted_4 = { class: "multiselecttags" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "multiselecttags" }
const _hoisted_7 = ["title", "onClick"]

import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import { User, Customer} from '@/models';
import CustomersPagination from './CustomerPagination.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Customerallocations',
  setup(__props) {

const customers = computed(() => store.getters['usermanagement/customers']);

const store = useStore();
const toasted = useToast();
const user = computed((): User => store.getters['usermanagement/selected']);
const users = computed((): User[] => store.getters['usermanagement/users']);
const setUserDeep = (payload: {
  path: string;
  data: any;
}) => {
  store.commit("usermanagement/setUserDeep", payload);
  store.commit('usermanagement/addUnsavedChange', payload.path)
};

const filteredgroups = computed(() => {
  let list = [];
  if (customers.value?.length) {
    customers.value
      .forEach((c: Customer) => {
        const i = list.findIndex((cg: any) => cg.name === c.companyName);
        if (i >= 0) {
          list[i].branches.push(c.branchName);
        } else {
          list.push({ name: c.companyName, branches: [c.branchName] });
        }
      });
      list = list.sort((i1: any, i2: any) => i1.name.localeCompare(i2.name));
      list.forEach((g: any) => {
        g.branches = g.branches.sort((b1: any, b2: any) => b1.localeCompare(b2))
      })
  }
  return list;
});

const remove = async (customer: Customer) => {
  if (customer?.id) {
    let newlist = user.value.customers.filter((c: Customer) => c.id != customer.id);
    setUserDeep({path: 'customers', data: [...newlist]})
  }
};

const isEntireCustomerAllocated = (companyName: string) => {
  const branches: Customer[] = customers.value.filter((c: Customer) => c.companyName === companyName);
  let result = false;
  if(user.value?.customers?.length) {
    const unallocated: Customer[] = branches.filter((c: Customer) => {
      const index = user.value.customers.findIndex((uc: Customer) => uc.companyName === companyName && uc.branchName === c.branchName);
      return index < 0;
    });
    result = (unallocated.length === 0);
  }
  return result;
}

const brachAllocationUser = (companyName: string, branchName: string) => {
  let allocatedToCurrentUser = allocatedToUser(user.value, companyName, branchName);
  let result = '';
  if(allocatedToCurrentUser) {
    result = user.value.name
  }
  else if(users.value?.length) {
    const index = users.value.findIndex((u: User) => {
      if(u.id === user.value.id) return false;
      const flag = allocatedToUser(u, companyName, branchName);
      return flag;
    });
    if(index >= 0) {
      result = users.value[index].name;
    }
  }
  return result;
}

const allocatedToUser = (u: User, companyName: string, branchName: string):boolean => {
  let result = false;
  if(u?.customers?.length) {
    const index = u.customers.findIndex((uc: Customer) => uc.companyName === companyName && uc.branchName === branchName);
    if(index >= 0) result = true;
  }
  return result;
}

const toggleAllocate = (companyName: string, branchName: string) => {
  const index = user.value.customers.findIndex((uc: Customer) => uc.companyName === companyName && uc.branchName === branchName);
  if(index >= 0) {
    user.value.customers.splice(index, 1);
    setUserDeep({path: 'customers', data: [...user.value.customers]});
  }
  else {
    const allocatedTo = brachAllocationUser(companyName, branchName);
    if(!allocatedTo) {
      const i = customers.value.findIndex((c: Customer) => c.companyName === companyName && c.branchName === branchName);
      if(i >= 0) {
        setUserDeep({path: 'customers', data: [...user.value.customers, new Customer(customers.value[i])]});
      }
    }
    else {
      toasted.warning(`Currently allocated to ${allocatedTo}`);
    }
  }
}

const toggleAllocateAll = (companyName: string) => {
  const list: Customer[] = customers.value.filter((uc: Customer) => uc.companyName === companyName);
  if(list.length) {
    let all = isEntireCustomerAllocated(companyName);
    let someunallocated = false;
    if(!all) {
      const i = list.findIndex((c: Customer) => {
        const allocatedTo = brachAllocationUser(c.companyName, c.branchName);
        if(!allocatedTo) return true;
        return false;
      });
      if(i >= 0) someunallocated = true;
    }

    if(all || !someunallocated) {
      list.forEach((c: Customer) => {
        const index = user.value.customers.findIndex((uc: Customer) => uc.companyName === c.companyName && uc.branchName === c.branchName);
        if(index >= 0) {
          user.value.customers.splice(index, 1);
        }
      });
    }
    else {
      list.forEach((c: Customer) => {
        const allocatedTo = brachAllocationUser(c.companyName, c.branchName);
        if(!allocatedTo) {
          const index = user.value.customers.findIndex((uc: Customer) => uc.companyName === c.companyName && uc.branchName === c.branchName);
          if(index < 0) {
            user.value.customers.push(new Customer(c));
          }
        }
      });
    }
    setUserDeep({path: 'customers', data: [...user.value.customers]});
  }
}

onMounted(async () => {
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomersPagination, { class: "mt-2" }),
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredgroups.value, (group, $groupindex) => {
          return (_openBlock(), _createElementBlock("tr", { key: $groupindex }, [
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", {
                  class: _normalizeClass(["multiselecttag", {active: isEntireCustomerAllocated(group.name)}]),
                  onClick: ($event: any) => (toggleAllocateAll(group.name))
                }, _toDisplayString(group.name), 11, _hoisted_5)
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.branches, (branch, $branchindex) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: _normalizeClass(["multiselecttag", {active: brachAllocationUser(group.name, branch) === user.value.name, passive: brachAllocationUser(group.name, branch) != '' && brachAllocationUser(group.name, branch) != user.value.name}]),
                    title: brachAllocationUser(group.name, branch),
                    onClick: ($event: any) => (toggleAllocate(group.name, branch)),
                    key: $branchindex
                  }, _toDisplayString(branch), 11, _hoisted_7))
                }), 128))
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})